<script lang="ts">
  import { timeSeriesApi, forecastApi, aiApi } from '../lib/api';
  import { t } from '../lib/i18n';
  
  // State
  let loading = false;
  let message = '';
  
  // Generate an invalid ID (using a negative number that isn't a valid ID)
  const invalidId = -9999;
  
  // Test functions
  async function testInvalidTimeSeries() {
    try {
      loading = true;
      message = '';
      
      // Attempt to fetch a non-existent time series
      await timeSeriesApi.getById(invalidId);
      
      message = t('Request should have failed but somehow succeeded');
    } catch (error) {
      message = t('Successfully logged a failed time series request');
    } finally {
      loading = false;
    }
  }
  
  async function testInvalidForecast() {
    try {
      loading = true;
      message = '';
      
      // Attempt to fetch a non-existent forecast
      await forecastApi.getById(invalidId, 999);
      
      message = t('Request should have failed but somehow succeeded');
    } catch (error) {
      message = t('Successfully logged a failed forecast request');
    } finally {
      loading = false;
    }
  }
  
  async function testInvalidAiAnalysis() {
    try {
      loading = true;
      message = '';
      
      // Attempt to run AI analysis on a non-existent time series
      await aiApi.analyze(invalidId, 'summary');
      
      message = t('Request should have failed but somehow succeeded');
    } catch (error) {
      message = t('Successfully logged a failed AI analysis request');
    } finally {
      loading = false;
    }
  }
  
  async function testNetworkError() {
    try {
      loading = true;
      message = '';
      
      // Attempt to connect to a non-existent endpoint
      await fetch('/non-existent-endpoint');
      
      message = t('Request should have failed but somehow succeeded');
    } catch (error) {
      message = t('Successfully logged a network error');
    } finally {
      loading = false;
    }
  }
</script>

<div class="test-api-logging">
  <h6 class="mb-3">{t('Test API Logging')}</h6>
  
  <div class="mb-3">
    <p class="text-muted small">
      {t('Use these buttons to generate failed API requests to test the logging system.')}
    </p>
  </div>
  
  {#if message}
    <div class="alert alert-info alert-dismissible fade show mb-3" role="alert">
      {message}
      <button 
        type="button" 
        class="btn-close" 
        on:click={() => message = ''} 
        aria-label={t('Close')}
      ></button>
    </div>
  {/if}
  
  <div class="d-grid gap-2">
    <button 
      class="btn btn-sm btn-outline-primary" 
      on:click={testInvalidTimeSeries}
      disabled={loading}
    >
      {#if loading}
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {/if}
      {t('Test Invalid Time Series Request')}
    </button>
    
    <button 
      class="btn btn-sm btn-outline-primary" 
      on:click={testInvalidForecast}
      disabled={loading}
    >
      {#if loading}
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {/if}
      {t('Test Invalid Forecast Request')}
    </button>
    
    <button 
      class="btn btn-sm btn-outline-primary" 
      on:click={testInvalidAiAnalysis}
      disabled={loading}
    >
      {#if loading}
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {/if}
      {t('Test Invalid AI Analysis Request')}
    </button>
    
    <button 
      class="btn btn-sm btn-outline-primary" 
      on:click={testNetworkError}
      disabled={loading}
    >
      {#if loading}
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {/if}
      {t('Test Network Error')}
    </button>
  </div>
</div>